export enum FiltersSkin {
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
}

export type FiltersSkinType = 'primary' | 'secondary' | 'tertiary';
